import React, {useCallback, useState} from 'react';

import {BulkActionFooter} from 'src/components/bulk-tool/bulk-action-footer';
import {GroupSuggest} from 'src/components/group-suggest';

import Button from '@pb/kit-component-button';
import {DialogHeader, DialogMain} from '@pb/kit-component-dialog-v2';
import {Group} from '@pb/kit-component-group';
import Label from '@pb/kit-component-label';
import {pluralize} from '@pb/kit-formatters';


import {GROUP_MODAL_TITLES} from '../constants';

import type {ProcessBulkAction} from 'src/components/bulk-tool/typedef';
import type {ActionOptions} from 'src/components/save-with-reason/action-with-reason-button';
import type {AccountGroup} from 'src/openapi/admin/models/AccountGroup';
import type {UpdateUserGroup} from 'src/openapi/admin/models/UpdateUserGroup';

type Props = {
    accountId: number,
    userIds: number[],
    onCloseModal: (submit: boolean) => void,
    processAction: ProcessBulkAction<UpdateUserGroup[]>,
};

export const AssignToGroupModal = ({accountId, userIds, onCloseModal, processAction}: Props) => {
    const [selectedGroup, setSelectedGroup] = useState<AccountGroup | null>(null);

    const updateGroup = useCallback(async (options?: ActionOptions) => {
        if (selectedGroup) {
            return await processAction(
                userIds.map(userId => ({
                    userId,
                    groupId: selectedGroup.id,
                })), options,
            );
        }
    }, [selectedGroup, userIds, processAction]);

    return (
        <>
            <DialogHeader onClose={() => onCloseModal(false)}>
                {GROUP_MODAL_TITLES.ASSIGN}
            </DialogHeader>
            <DialogMain style={{padding: 24}}>
                <Group direction="v">
                    <div>{pluralize('Assign the selected user[s] to a group', userIds.length)}</div>
                    <Group direction="v" gap="xs">
                        <Label htmlFor="account-group-suggest">Account Group</Label>
                        <GroupSuggest
                            id="account-group-suggest"
                            placeholder="Select target group"
                            width={350}
                            accountId={accountId}
                            selectedGroupId={selectedGroup?.id || null}
                            onSelect={setSelectedGroup}
                        />
                    </Group>
                </Group>
            </DialogMain>
            <BulkActionFooter action="Update" onConfirm={updateGroup} disabled={!selectedGroup}>
                <Group>

                    <Button variant="Type.SECONDARY" onClick={() => onCloseModal(false)}>
                        Cancel
                    </Button>
                </Group>
            </BulkActionFooter>
        </>
    );
};
